import {
  AuditColumnModel,
  ButtonModel,
  DimensionModel,
  MousePointModel,
  OffsetModel,
  PositionType,
} from 'src/app/model';

export enum ZonePlanGroup {
  AVAILABLE = 'Available',
  MAPPED = 'Mapped',
}

export enum ZonePlanButtonGroup {
  ADD = 'add',
  VIEW = 'view',
  EDIT = 'edit',
  AVAILABLE = 'available',
  MAPPED = 'mapped',
  TAGCAMERA = 'tagCamera',
  UNTAGCAMERA = 'untagCamera',
}

export type ZonePlanGroupType = ZonePlanGroup.AVAILABLE | ZonePlanGroup.MAPPED;

export type ZonePlanButtonGroupType =
  | ZonePlanButtonGroup.EDIT
  | ZonePlanButtonGroup.VIEW
  | ZonePlanButtonGroup.ADD
  | ZonePlanButtonGroup.MAPPED
  | ZonePlanButtonGroup.AVAILABLE
  | ZonePlanButtonGroup.TAGCAMERA
  | ZonePlanButtonGroup.UNTAGCAMERA;

export interface ZonePlanModel extends Pick<AuditColumnModel, '_id'> {
  name: string;
  floorPlan: string | null;
  geoFence: any;
  assetCount?: number;
  deviceCount?: number;
  zoneBreadCrumb?: string[];
}

export interface ZonePlanEntityPayloadModel {
  zoneId?: string;
  zoneIds?: string[];
  siteId: string;
  searchKey: string;
  hierarchyId: string;
}

export interface ZonePlanEntityModel {
  available: boolean;
  entityId: string;
  entityName: string;
  deviceId?: string;
  deviceOid?: string;
  deviceName: string;
  uniqueId: string;
  mappingId: string;
  coordinates: MousePointModel;
  zones: string[];
  type: number;
  category: string;
  lastActiveTime?: string;
  alertsCount?: number;
  active?: boolean;
  healthStatus?: boolean;
  relationalEntity?: {
    count: number;
    alertsCount: number;
    entityIds: string[];
  };
  // New properties from planogramEntityList
  trackedState?: string;
  tisDisplayValue?: string;
  sourceTimeDisplayValue?: string;
  tag?: string[];
  workTableZone?: { _id: string; name: string }[];
  attributes?: Array<{
    attributeName: string;
    attributeValue: string;
    windowAvg?: string;
    RateDiff?: string;
    operation?: string;
    RawValue?: string;
  }>;
  status?: string; 
  isRecentTimestamp ?: boolean;
}

export interface ZonePlanEntityRelationalModel {
  trackerId: string;
  trackerCategory: string;
  detectedCategoryDetails: ZonePlanRelationalModel[];
}

export interface ZonePlanRelationalModel {
  count: number;
  entityCategory: string;
  alertsCount: number;
  entityIds?: string[];
}

export interface ZonePlanEntityGroupModel {
  title: string;
  active: boolean;
  list: ZonePlanEntityModel[];
  listGroup: ZonePlanGroupType;
  buttonGroup: ZonePlanButtonGroupType;
  activeEntity: boolean;
  disabled: boolean;
}

export interface ZonePlanButtonModel extends ButtonModel {
  group: ZonePlanButtonGroupType;
  relationalGroup: ZonePlanButtonGroupType;
  class?: string;
}

export interface ZonePlanPlotConfigModel {
  plan: DimensionModel;
  viewPlan: DimensionModel;
  marker: DimensionModel;
  plotAdjuster: OffsetModel;
  saveAdjuster: OffsetModel;
}

export interface ZonePlanEntityLocationPayloadModel {
  entityId: string;
  mappingId: string;
  coordinates: MousePointModel;
  zones: string[];
}

export interface ZonePlanEntityLocationDeletePayloadModel {
  entityId: string[];
  siteId: string;
}

export interface ZonePlanVisibleCategoryModel {
  [s: string]: ZonePlanCategoryOptionModel;
}

export interface ZonePlanCategoryOptionModel {
  subCategoryTracked: string[];
  showHealthStatus: boolean;
}

export interface ZonePlanAggregationPayloadModel {
  zoneId: string;
  siteId: string;
  categories: ZonePlanAggregationCategoryModel[];
  from?: string;
  to?: string;
}

export interface ZonePlanAggregationCategoryModel {
  trackerCategory: string;
  entityCategory: string[];
  includeInTracker?: boolean;
}

export interface ZonePlanTrackerEntityCountModel {
  zoneId: string;
  entityCount: number;
  trackerCount: number;
}

export interface ZonePlanTrackerEntityCountPayloadModel {
  trackerCategory: string[];
  entityCategory: string[];
  siteId?: string;
  includeUnspecifiedEntities?: boolean;
  entities?: string[];
}
